/**
 * Detects if the current browser is Safari (desktop or iOS).
 * Explicitly excludes Chrome and Android WebViews that also include "Safari" in their UA.
 */
export const isSafari = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  // Chrome, Chromium-based browsers, and Android include "Chrome" or "CriOS" — exclude them
  return /^((?!chrome|crios|android|fxios).)*safari/i.test(ua);
};

/**
 * Returns true if the given axios error is a network-level failure
 * that is safe to retry (not a 4xx/5xx application error).
 */
export const isRetryableAxiosError = (error) => {
  if (!error) return false;
  // Never retry if the server actually responded with a status code
  if (error.response) return false;
  const retryCodes = ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT', 'ECONNRESET'];
  return retryCodes.includes(error.code) || error.message === 'Network Error';
};
